var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.2932 7.29262C12.6838 6.90225 13.317 6.90249 13.7074 7.29316L21.7074 15.2993C22.0975 15.6898 22.0975 16.3225 21.7074 16.713L13.7197 24.7068C13.3293 25.0975 12.6961 25.0978 12.3055 24.7074C11.9148 24.317 11.9145 23.6838 12.3049 23.2932L19.5863 16.0062L12.2926 8.70683C11.9022 8.31616 11.9025 7.683 12.2932 7.29262Z",
    fill: "#000000",
    fillOpacity: 1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronRight);
export default __webpack_public_path__ + "static/media/chevron-right.30481fba25360ddd596fd3f4a18c03ae.svg";
export { ForwardRef as ReactComponent };